"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
//
// assets
//
const heroBackground_webp_1 = __importDefault(require("../../../assets/images/heroBackground.webp"));
//
// properties
//
const config_1 = require("../../../assets/styles/config");
exports.default = styled_components_1.default.div `
  align-items: center;
  flex-direction: column;
  justify-content: center;
  min-width: 100%;
  object-fit: cover;

  @media ${config_1.device.laptop} {
    background-image: url(${heroBackground_webp_1.default});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
  }
`;
